import dataAdapter from '../adapters/gon'

export const getDataFromHeadTag = (name: string) => dataAdapter.get(name)
export const setDataInHeadTag = (name: string, value: unknown) =>
  dataAdapter.set(name, value)
